// @flow
import React, { useEffect } from 'react';
import { BrowserRouter, Route, useLocation, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import checkCookie from '~/lib/checkCookie';
import _ from 'shared/lib/gettext';
import Login from './Login';
import Admin from './Admin';
import PrivateRoute from './PrivateRoute';
import FlashMessage from './FlashMessage';
import ConfirmationModal from './ConfirmationModal';
import { flashMessage as showFlashMessage } from '../actions';

const publishMessagesByCode = {
  '0': _('PUBLISH_SUCCESS'),
  '1': _('ERROR_PUBLISH_NO_USER'),
  '2': _('ERROR_PUBLISH_NONEXISTENT_PAGE'),
  '3': _('ERROR_PUBLISH_NONEXISTENT_VERSION'),
  '4': _('ERROR_PUBLISH_CONFLICT'),
  '5': _('ERROR_PUBLISH_SCHEDULED')
};

type Props = {
  flashMessage: {
    message: string,
    type: string
  },
  location: Object,
  showMessage: (message: string, type: string) => void
};

const App = (props: Props) => {
  const { flashMessage, showMessage } = props;

  const location = useLocation();
  const { search } = location;

  useEffect(() => {
    const checkFlashMessages = () => {
      const urlParams = new URLSearchParams(search);
      const hasPublishResult = urlParams.has('publishresult');

      if (hasPublishResult) {
        const msgCode = urlParams.get('publishresult');
        const msg = publishMessagesByCode[msgCode];
        const msgType = (+msgCode > 0) ? 'ERROR' : 'SUCCESS';

        showMessage(msg, msgType, 3000);
      }
    }

    checkFlashMessages();
  }, [search, showMessage]);

  const cookieDisabled = !checkCookie() && (
    <ConfirmationModal
      message="Please enable cookies to continue."
    />
  );

  return (
    <div style={{ width: '100%', height: '100%' }}>
      {/* One or the other: the private route also matches /admin/login, and its sign-in redirect
          would drop the address's ?next= (where to go after signing in). */}
      <Switch>
        <Route exact path="/admin/login" component={Login} />
        <PrivateRoute path="/admin" component={Admin} />
      </Switch>

      {flashMessage &&
        <FlashMessage
          message={flashMessage.message}
          type={flashMessage.type}
        />
      }

      {cookieDisabled}
    </div>
  );
}

const mapStateToProps = state => ({
  flashMessage: state.app.flashMessage,
});

const mapDispatchToProps = (dispatch: $FlowIGNORE) => ({
  showMessage: (...args) => dispatch(showFlashMessage(...args))
});

const ConnectedApp = connect(mapStateToProps, mapDispatchToProps)(App);

// Wrap app with BrowserRouter for location access
const RouterApp = (props) => (
  <BrowserRouter>
    <ConnectedApp {...props} />
  </BrowserRouter>
);

export default RouterApp;
